import React from "react";

import EntitySelect from "../../../component/EntitySelect";
import fieldIcon from "./fieldIcons";

/* The antd entity dropdown, not the legacy react-select `EntityDropdown` — one control kit per
   screen (spec/02).
 *
 * ⚠ The stored value is the full option OBJECT in both modes now (it used to be a bare id for
 * single-value fields). `saveItem` unwraps entity fields to ids before POST/PATCH, and an object
 * can label itself: a bare id makes the select show "52" until it has fetched page 1 to find the
 * name, which is exactly what a just-picked value should never have to do.
 */
export default function EntityField({ field, value, onChange, item = {} }) {
  return (
    <EntitySelect
      entity={field.entity}
      value={value}
      isMulti={!!field.isMulti}
      /* County scope, applied by EntitySelect for point entities only. */
      county={field.scopeBy ? item[field.scopeBy] : undefined}
      /* Create/edit pickers offer ACTIVE related objects only — a deactivated one cannot be
         saved. A descriptor overrides via `field.query`. */
      extraQuery={{ active: true, ...(field.query || {}) }}
      prefix={fieldIcon(field)}
      /* `tall` shows every chip in a wrapping, scrollable area; a plain wide multi shows as many as
         fit on one line then `+N`; a normal-width one keeps the single-chip `+N`. */
      tall={!!field.tall}
      maxTagCount={field.tall ? undefined : field.isMulti && field.wide ? "responsive" : 1}
      placeholder={field.placeholder}
      ariaLabel={field._label}
      onChange={option => onChange(field.name, field.isMulti ? option || [] : option || null)}
    />
  );
}
